import { MessageBox } from 'element-ui'
import Cookies from 'js-cookie'
import CryptoJS from 'crypto-js'
import router from '@/router'

// 公共方法
export const common = {
  // 判断登录
  showConfirmLogin() {
    this.confirm({
      title: '提示',
      content: '请先登录, 是否前往登录?'
    }, () => {
      router.push({ path: '/login' })
    })
  },

  // confirm弹出框
  confirm: function (params, okCall, cancalCall) {
    MessageBox.confirm(params.content || '', params.title || '', {
      customClass:
        'cus-confirm' + (params.className ? ' ' + params.className : ''),
      showClose: params.showClose || false,
      showCancelButton: params.showCancelButton || true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      center: false,
      dangerouslyUseHTMLString: true
      // showClose: false
    })
      .then(() => {
        okCall && okCall()
      })
      .catch(() => {
        cancalCall && cancalCall()
      })
  },

  formatDateString: function (date, fmt) {
    if (typeof date == "string") {
      date = new Date(date);
    }
    if (typeof date == "number") {
      date = new Date(date);
    }
    if (typeof date == "undefined" || date == null) {
      return "";
    }

    var o = {
      "M+": date.getMonth() + 1, //月份 
      "d+": date.getDate(), //日 
      "h+": date.getHours(), //小时 
      "m+": date.getMinutes(), //分 
      "s+": date.getSeconds(), //秒 
      "q+": Math.floor((date.getMonth() + 3) / 3), //季度 
      "S": date.getMilliseconds() //毫秒 
    };
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
      if (new RegExp("(" + k + ")").test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
      }
    }
    return fmt;
  },
}

/**
 * @param {校验的字符串} str
 * @param {校验类型 'phone' 'password' 'numLetter':数字+字母, 'numForward':正整数, 'numDecimal':最多保留两位, numberDecimal:数字} type
 * @Auth zhangwei
 * @date 20181029
 */
export const validate = (str, type) => {
  let isMatch = false,
    isNum = /^[0-9]+.?[0-9]*$/, // 非负数
    isMobile = /^1[3578]\d{9}$|^147\d{8}$/,
    ispass = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,20}$/, // 6-20位字符；数字、字母、特殊字符（除空格），起码其中两种组合
    isNumAndLetter = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{2,30}$/, // 2-30位字母加数字
    isNumForward = /^[0-9]*[1-9][0-9]*$/, // 正整数
    isNumDecimal = /((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/, // 最多保留两位
    isDecimal = /^-?\d*\.?\d*$/, //数字
    isIdCard = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/ //身份证-弱校验
  // isIdCard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/ //身份证-强校验

  switch (type) {
    case 'phone':
      if (isMobile.test(str)) {
        isMatch = true
      }
      break
    case 'password':
      if (ispass.test(str)) {
        isMatch = true
      }
      break
    case 'number':
      if (isNum.test(str)) {
        isMatch = true
      }
      break
    case 'numLetter':
      if (isNumAndLetter.test(str)) {
        isMatch = true
      }
      break
    case 'numForward':
      if (isNumForward.test(str)) {
        isMatch = true
      }
      break
    case 'numDecimal':
      if (isNumDecimal.test(str)) {
        isMatch = true
      }
      break
    case 'numberDecimal':
      if (isDecimal.test(str)) {
        isMatch = true
      }
      break
    case 'idCard':
      // 弱校验
      if (isIdCard.test(str)) {
        isMatch = true
      }
      // 强校验
      // if (isIdCard.test(str)) {
      //   if (str.length == 18) {
      //     var idCardWi = new Array(
      //       7,
      //       9,
      //       10,
      //       5,
      //       8,
      //       4,
      //       2,
      //       1,
      //       6,
      //       3,
      //       7,
      //       9,
      //       10,
      //       5,
      //       8,
      //       4,
      //       2
      //     ) // 将前17位加权因子保存在数组里
      //     var idCardY = new Array(1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2) // 这是除以11后，可能产生的11位余数、验证码，也保存成数组
      //     var idCardWiSum = 0 // 用来保存前17位各自乖以加权因子后的总和
      //     for (var i = 0; i < 17; i++) {
      //       idCardWiSum += str.substring(i, i + 1) * idCardWi[i]
      //     }

      //     var idCardMod = idCardWiSum % 11 // 计算出校验码所在数组的位置
      //     var idCardLast = str.substring(17) // 得到最后一位身份证号码

      //     // 如果等于2，则说明校验码是10，身份证号码最后一位应该是X
      //     if (idCardMod == 2) {
      //       if (idCardLast == 'X' || idCardLast == 'x') {
      //         //alert("恭喜通过验证啦！");
      //         isMatch = true
      //       } else {
      //         //alert("身份证号码错误！");
      //       }
      //     } else {
      //       // 用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
      //       if (idCardLast == idCardY[idCardMod]) {
      //         //alert("恭喜通过验证啦！");
      //         isMatch = true
      //       } else {
      //         //alert("身份证号码错误！");
      //       }
      //     }
      //   }
      // }
      break
  }

  return isMatch
}

/**
 * 存储cookie信息并加密
 * @param {字段名} str
 * @param {值} val
 */
export const setCookieEncrypt = (str, val) => {
  // 单馆的代码
  // let encJson1 = CryptoJS.AES.encrypt(val, process.env.VUE_APP_SALT).toString()
  // let encData1 = CryptoJS.enc.Base64.stringify(
  //   CryptoJS.enc.Utf8.parse(encJson1)
  // )
  // Cookies.set(str, encData1, { expires: 7 })


  // 对象
  // let ciphertext = CryptoJS.AES.encrypt(JSON.stringify(val), process.env.VUE_APP_SALT).toString()
  // Cookies.set(str, ciphertext, { expires: 7 })

  // 字符串
  let ciphertext = CryptoJS.AES.encrypt(val, process.env.VUE_APP_SALT).toString()
  Cookies.set(str, ciphertext, { expires: 7 })

}

// 获取cookie信息解密
export const getCookieDecrypt = str => {
  // 单馆的代码
  // if (Cookies.get(str)) {
  //   let decData1 = CryptoJS.enc.Base64.parse(Cookies.get(str)).toString(
  //     CryptoJS.enc.Utf8
  //   )

  //   let decStr = CryptoJS.AES.decrypt(
  //     decData1,
  //     process.env.VUE_APP_SALT
  //   ).toString(CryptoJS.enc.Utf8)

  //   return decStr
  // }
  // return false

  // 对象
  // let bytes = CryptoJS.AES.decrypt(Cookies.get(str), process.env.VUE_APP_SALT)
  // let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
  // return decryptedData

  // 字符串
  // if (Cookies.get(str)) {
  //   let bytes = CryptoJS.AES.decrypt(Cookies.get(str), process.env.VUE_APP_SALT)
  //   let originalText = bytes.toString(CryptoJS.enc.Utf8)
  //   return originalText
  // }
  return ''
}
